(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5050],{

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 35050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SideBar_SideBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-waypoint/es/index.js + 1 modules
var es = __webpack_require__(83824);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/coverletter/modules/getCoverLetterTypeFromTab.ts
var getCoverLetterTypeFromTab = __webpack_require__(59976);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/components/Footer/index.ts
var Footer = __webpack_require__(45464);
// EXTERNAL MODULE: ./src/components/Pagination.tsx
var Pagination = __webpack_require__(83740);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/useSearchState.ts
var useSearchState = __webpack_require__(70665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterList/CoverLetterListContent.tsx + 2 modules
var CoverLetterListContent = __webpack_require__(61813);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterScrap.tsx
var CoverLetterScrap = __webpack_require__(41678);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/LoadingListItem.tsx
var LoadingListItem = __webpack_require__(77391);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/NotFound.tsx
var NotFound = __webpack_require__(56683);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/app.feature/coverletter/constant/index.ts
var constant = __webpack_require__(75609);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/hooks/useKeywordHighlighter.ts
var useKeywordHighlighter = __webpack_require__(17683);
;// CONCATENATED MODULE: ./src/style/utils.ts
var getEllipsisProps = function(maxLine) {
    return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkit-line-clamp": maxLine,
        "-webkit-box-orient": "vertical",
        // for IE
        lineHeight: "24px",
        maxHeight: 24 * maxLine
    };
};

// EXTERNAL MODULE: ./src/utils/arrayFilterJoin.ts
var arrayFilterJoin = __webpack_require__(68182);
// EXTERNAL MODULE: ./src/utils/coverLetter.ts
var utils_coverLetter = __webpack_require__(5126);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMobileContent.tsx
var CoverLetterListItemMobileContent = __webpack_require__(30830);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMoMui.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterListItemMobile_coverLetter on CoverLetter {\n    id\n    role\n    contentSummaryMobile: content(length: 150)\n    organizationName\n    types\n    ...CoverLetterUtils_getSpecInfo_coverLetter\n    ...CoverLetterUtils_getPassedAtText_coverLetter\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        content: {
            "& b": {
                backgroundColor: "#bbe6ff",
                color: theme.palette.text.primary
            }
        },
        contentEllipsis: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getEllipsisProps(2)), {
            "& b": {
                color: theme.palette.text.primary
            }
        }),
        mobileBasicInfo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            fontSize: 16,
            marginBottom: 5
        }, getEllipsisProps(1)), {
            "& .highlight": {
                fontWeight: 600
            },
            fontWeight: 500
        }),
        specInfo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            marginBottom: 5
        }, getEllipsisProps(1)), {
            fontSize: 12
        }),
        link: {
            "&:hover": {
                textDecoration: "underline"
            }
        }
    };
});
var CoverLetterListItemMoMui = function(param) {
    var coverLetter = param.coverLetter, LinkProps = param.LinkProps, coverLetterHighlight = param.coverLetterHighlight, classesProp = param.classes;
    var ref;
    var classes = useStyles({
        classes: classesProp
    });
    var search = (0,useSearchState/* useSearchStateContext */.az)().search;
    var highlightedOrgName = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName) || "-",
        keyword: search.organizationName
    });
    var highlightedRole = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role) || "-",
        keyword: search.role
    });
    var passedAt = (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter);
    var typesText = coverLetter === null || coverLetter === void 0 ? void 0 : (ref = coverLetter.types) === null || ref === void 0 ? void 0 : ref.map(function(type) {
        if (!type) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        return "".concat(constant/* COVER_LETTER_TYPE_TEXT_OBJECT */.U[type]);
    }).join(", ");
    var highlightContent = [];
    if (coverLetterHighlight && coverLetterHighlight.length > 0) {
        highlightContent.push(coverLetterHighlight[0]);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes.link
    }, LinkProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "block",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classes.mobileBasicInfo,
                    dangerouslySetInnerHTML: {
                        __html: (0,arrayFilterJoin/* default */.Z)([
                            highlightedOrgName,
                            highlightedRole,
                            passedAt,
                            typesText, 
                        ])
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: classes.specInfo,
                    children: (0,utils_coverLetter/* getSpecInfo */.t)(coverLetter)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListItemMobileContent/* default */.Z, {
                    content: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.contentSummaryMobile) || "",
                    highlight: highlightContent,
                    typographyProps: {
                        className: (0,clsx_m/* default */.Z)(classes.content, classes.contentEllipsis)
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemMoMui = (CoverLetterListItemMoMui);
src_default()(_templateObject());

// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/SideBar/SideBarContent.tsx

function SideBarContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemScreen_SideBarContent_currentUser on User {\n    ...CoverLetterScrap_currentUser\n  }\n  fragment CoverLetterItemScreen_SideBarContent_coverLetterElasticEdge on CoverLetterElasticEdge {\n    highlight\n    node {\n      id\n      ...CoverLetterScrap_coverLetter\n      ...CoverLetterListItemMobile_coverLetter\n    }\n  }\n"
    ]);
    SideBarContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .item {\n      width: 100%;\n      display: flex;\n      padding: 20px;\n      border-bottom: 1px solid #eee;\n      justify-content: space-between;\n      align-items: center;\n\n      @media (max-width: 600px) {\n        background-color: ",
        ";\n      }\n    }\n\n    .active-item {\n      background-color: #f2faff;\n      border: 1px solid ",
        " !important;\n\n      @media (max-width: 600px) {\n        background-color: #f4f4f4;\n        border: none;\n      }\n    }\n\n    .scrap {\n      width: 50px;\n      text-align: center;\n      margin-left: 20px;\n      flex-shrink: 0;\n\n      @media (max-width: 600px) {\n        margin-left: 0;\n      }\n    }\n\n    .is-scrapped {\n      color: ",
        " !important;\n      font-weight: 500;\n    }\n\n    .scrap-count {\n      font-size: 16px;\n      font-weight: normal;\n      color: #999;\n    }\n\n    .scrap-button {\n      color: #e8e8e8;\n      padding-bottom: 5px;\n      background-color: transparent;\n      border: none;\n      padding: 12px 12px 0px;\n      cursor: pointer;\n\n      @media (hover: hover) and (pointer: fine) {\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .spec-info {\n      @media (min-width: 960px) {\n        font-size: 16px;\n        color: #999;\n      }\n    }\n\n    .content {\n      @media (min-width: 960px) {\n        font-size: 16px;\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var SideBarContent = function(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, _coverLetterEdges = param.coverLetterEdges, coverLetterEdges = _coverLetterEdges === void 0 ? [] : _coverLetterEdges, currentUser = param.currentUser;
    var router = (0,next_router.useRouter)();
    var context = (0,useSearchState/* useSearchStateContext */.az)();
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingListItem/* default */.Z, {
            length: 20,
            variant: "mobile"
        });
    }
    var coverLetters = coverLetterEdges;
    if ((coverLetters === null || coverLetters === void 0 ? void 0 : coverLetters.length) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: coverLetters.map(function(edge) {
            var ref, ref1, ref2;
            var coverLetter = edge.node;
            var LinkProps = (0,CoverLetterListContent/* getCoverLetterItemLinkProps */.AB)(context, coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id);
            var isActive = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id) === (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id);
            if (!(edge === null || edge === void 0 ? void 0 : (ref1 = edge.node) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item ".concat(isActive ? "active-item" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterList_CoverLetterListItemMoMui, {
                        coverLetter: coverLetter,
                        LinkProps: LinkProps,
                        coverLetterHighlight: edge.highlight,
                        classes: {
                            specInfo: "spec-info",
                            content: "content"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "scrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrap/* default */.Z, {
                            coverLetter: coverLetter,
                            currentUser: currentUser,
                            children: function(param) {
                                var scrapCoverLetter = param.scrapCoverLetter, loading = param.loading, scrapCount = param.scrapCount;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: scrapCoverLetter,
                                            className: "scrap-button ".concat((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? "is-scrapped" : ""),
                                            disabled: loading,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
                                                isOn: !!(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped),
                                                className: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? "is-scrapped" : "",
                                                strokeType: "#666666"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "scrap-count ".concat((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? "is-scrapped" : ""),
                                            children: (scrapCount || 0) >= 1000 ? "999+" : scrapCount
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }, edge === null || edge === void 0 ? void 0 : (ref2 = edge.node) === null || ref2 === void 0 ? void 0 : ref2.id);
        })
    });
};
src_default()(SideBarContent_templateObject());
/* harmony default export */ var SideBar_SideBarContent = (SideBarContent);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SideBarContent__StyledWrapper",
    componentId: "sc-fa619207-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.background.bg_8, theme.color.primary_2, theme.color.primary_2, theme.color.primary_2, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/SideBar/SideBar.tsx



function SideBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemScreen_SideBar_currentUser on User {\n    ...CoverLetterItemScreen_SideBarContent_currentUser\n  }\n\n  query CoverLetterItemScreen_SideBar(\n    $filterBy: CoverLetterFilter!\n    $orderBy: CoverLetterOrder\n    $pagination: Pagination\n  ) {\n    coverLetters(\n      filterBy: $filterBy\n      orderBy: $orderBy\n      pagination: $pagination\n    ) {\n      edges {\n        node {\n          id\n        }\n        ...CoverLetterItemScreen_SideBarContent_coverLetterElasticEdge\n      }\n      totalCount\n    }\n  }\n"
    ]);
    SideBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 440px;\n  border-right: 1px solid #eeeeee;\n\n  @media (min-width: 960px) {\n    flex: 1 1 0px;\n    overflow-y: auto;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n\n  .list {\n    ",
        " {\n      margin-top: 30px;\n    }\n  }\n\n  .item {\n    width: 100%;\n    display: flex;\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    align-items: center;\n\n    ",
        " {\n      background-color: #fff;\n    }\n  }\n\n  .total-count {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .total-count-wrapper {\n    padding: 13px 20px;\n    border-right: 1px solid #eee;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    background-color: #fafafa;\n  }\n\n  .list-pagination {\n    ",
        " {\n      padding-bottom: 20px;\n    }\n  }\n\n  .footer {\n    text-align: center;\n    margin-top: 20px;\n  }\n"
    ]);
    SideBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var SideBar = function(param) {
    var onScrollEnter = param.onScrollEnter, onScrollLeave = param.onScrollLeave, currentUser = param.currentUser;
    var ref, ref1;
    var theme = (0,useTheme/* default */.Z)();
    var isMdUp = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var context = (0,useSearchState/* useSearchStateContext */.az)();
    var currentTab = context.tabState, search = context.search, orderBy = context.orderBy, pagination = context.pagination, page = context.page;
    var pageSize = 20;
    var ref2 = (0,graphql/* useCoverLetterItemScreen_SideBarQuery */.kmC)({
        variables: {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
                types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(currentTab),
                status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                numberOfFragments: 1,
                fragmentSize: 100
            }),
            orderBy: {
                field: orderBy === null || orderBy === void 0 ? void 0 : orderBy.orderField,
                direction: orderBy === null || orderBy === void 0 ? void 0 : orderBy.orderDirection
            },
            pagination: {
                page: page,
                pageSize: pageSize
            }
        }
    }), data = ref2.data, loading = ref2.loading;
    var ref3;
    var totalCount = (ref3 = data === null || data === void 0 ? void 0 : (ref = data.coverLetters) === null || ref === void 0 ? void 0 : ref.totalCount) !== null && ref3 !== void 0 ? ref3 : 0;
    (0,react.useEffect)(function() {
        if (!isMdUp) {
            return;
        }
        pagination.setNumberOfPages(Math.ceil(totalCount / pageSize));
        window.scrollTo(0, 0);
    }, [
        pageSize,
        totalCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideBar_StyledWrapper, {
        onWheel: function(event) {
            return event.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
                onEnter: onScrollEnter,
                onLeave: onScrollLeave
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                smDown: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "total-count-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "total-count",
                        children: [
                            "검색결과 ",
                            totalCount,
                            "건"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar_SideBarContent, {
                        coverLetterEdges: (data === null || data === void 0 ? void 0 : (ref1 = data.coverLetters) === null || ref1 === void 0 ? void 0 : ref1.edges) || [],
                        currentUser: currentUser,
                        loading: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-pagination",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                            smDown: true,
                            implementation: "css",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    pagination: pagination
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                    variant: "mobile",
                                    className: "footer"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
src_default()(SideBar_templateObject());
/* harmony default export */ var SideBar_SideBar = (/*#__PURE__*/(0,react.memo)(SideBar, function(prevProps, nextProps) {
    return (prevProps === null || prevProps === void 0 ? void 0 : prevProps.onScrollEnter) === (nextProps === null || nextProps === void 0 ? void 0 : nextProps.onScrollEnter) && (prevProps === null || prevProps === void 0 ? void 0 : prevProps.onScrollLeave) === (nextProps === null || nextProps === void 0 ? void 0 : nextProps.onScrollLeave) && (prevProps === null || prevProps === void 0 ? void 0 : prevProps.currentUser) === (nextProps === null || nextProps === void 0 ? void 0 : nextProps.currentUser);
}));
var SideBar_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SideBar__StyledWrapper",
    componentId: "sc-b066c2d-0"
})(SideBar_templateObject1(), media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/SideBar/index.ts



/***/ }),

/***/ 77391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98913);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96679);
/* harmony import */ var svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49123);













var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            backgroundColor: "white",
            padding: "20px 0",
            width: "100%",
            borderBottom: "1px solid #fafafa"
        },
        flexWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        scrapButton: {
            color: "#e8e8e8"
        },
        bookmarkIcon: {
            width: 15
        },
        basicInfo: {
            width: 100,
            marginRight: 25,
            flexShrink: 0,
            alignItems: "center",
            display: "flex"
        },
        specInfo: {
            marginRight: 3.75,
            marginBottom: 0.5,
            width: "100%",
            flexGrow: 0,
            flexShrink: 0
        },
        content: {
            marginRight: 3.75,
            marginBottom: 0.5,
            marginTop: 5,
            width: "100%",
            flexGrow: 1
        },
        contentWrapper: {
            mr: 3.75,
            flexGrow: 1,
            display: "flex",
            minWidth: 0,
            maxWidth: "100%",
            flexDirection: "column",
            alignItems: "flex-start"
        },
        mobileSkeleton: {
            marginBottom: 5
        },
        scrapIcon: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            flexShrink: 0,
            marginLeft: 55
        }, theme.breakpoints.down("sm"), {
            marginLeft: 10
        })
    };
});
var LoadingItem = function(param) {
    var className = param.className, _variant = param.variant, variant = _variant === void 0 ? "auto" : _variant;
    var classes = useStyles();
    var columnTimes = lodash_times__WEBPACK_IMPORTED_MODULE_2___default()(4);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.root, classes.flexWrapper, className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    smDown: variant === "auto" || variant === "mobile",
                    mdUp: variant === "mobile",
                    implementation: "css",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.flexWrapper,
                        children: [
                            columnTimes.map(function(column) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    className: classes.basicInfo,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        width: 100
                                    })
                                }, column);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                flexGrow: 1,
                                display: "flex",
                                minWidth: 0,
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    className: classes.contentWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: classes.specInfo,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                height: 16,
                                                width: 350
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: classes.content,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                height: 70,
                                                width: 500
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    mdUp: variant === "auto" || variant === "pc",
                    implementation: "css",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.flexWrapper,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            display: "block",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 200,
                                    height: 20,
                                    className: classes.mobileSkeleton
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 250,
                                    height: 20,
                                    className: classes.mobileSkeleton
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 280,
                                    height: 35,
                                    className: classes.mobileSkeleton
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.scrapIcon,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        className: classes.scrapButton,
                        disabled: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: classes.bookmarkIcon
                        })
                    })
                })
            ]
        })
    });
};
var LoadingListItem = function(_param) {
    var length = _param.length, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "length"
    ]);
    var lodingItems = lodash_times__WEBPACK_IMPORTED_MODULE_2___default()(length);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: lodingItems.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadingItem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props))
            }, item);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingListItem);


/***/ })

}]);